import React from 'react';
import { Redirect, Route, Switch as ReactRouterSwitch } from 'react-router';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/Access';

import { useCurrentAliceApp } from '../../hooks/useCurrentAliceApp';
import { useSharingPageMenuItems } from '../../hooks/useSharingPageMenuItems';
import { routes } from '../../lib/routes';
import { SkillAccess } from '../../model/settings';
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';
import Menu from '../Menu/Menu';
import { PageContent, PageHeadline, PageMain } from '../Typo/Typo';

import { LinksPage } from './LinksPage/LinksPage';
import { UsersPage } from './UsersPage/UsersPage';

const t = i18n(keyset);

export const SharingPage: React.FC<{ disabled: boolean }> = ({ disabled }) => {
    const skill = useCurrentAliceApp()!;
    const { menuItems, display } = useSharingPageMenuItems(skill);

    if (!skill.onAir || skill.skillAccess !== SkillAccess.Private) {
        return (
            <div>
                <PageHeadline title={t('header')} />
                <div>{t('error-only-private')}</div>
            </div>
        );
    }

    return (
        <ErrorBoundary withHomepageLink>
            <div>
                <PageHeadline title={t('header')} />
                <Menu items={menuItems} disabled={disabled} />
                <PageContent>
                    <PageMain>
                        <ReactRouterSwitch>
                            {display.main && (
                                <Route path={routes.app.skillPage(false, 'sharing/main', skill.id)}>
                                    {() => <LinksPage disabled={disabled} />}
                                </Route>
                            )}
                            {display.users && (
                                <Route path={routes.app.skillPage(false, 'sharing/users', skill.id)}>
                                    <UsersPage disabled={disabled} />
                                </Route>
                            )}
                            <Redirect
                                exact
                                from={routes.app.skillPage(false, 'sharing', skill.id)}
                                to={routes.app.skillPage(false, 'sharing/main', skill.id)}
                            />
                        </ReactRouterSwitch>
                    </PageMain>
                </PageContent>
            </div>
        </ErrorBoundary>
    );
};
